import type { ReactElement } from 'react';

import { IconInfoCircleOutline } from '@iwoca/icons';
import { Tooltip } from '@iwoca/orion';
import { clsx } from 'clsx';

import { iwocapayTelDisplay } from '../../../constants.json';
import { useSuspenseIsLockedOutDueToDecline } from '../../hooks/useSuspenseIsLockedOutDueToDecline';

export function DeclineLockOutMessage({
  compact = false,
}: {
  compact?: boolean;
}) {
  const declineLockOut = useSuspenseIsLockedOutDueToDecline();
  if (!declineLockOut.isLockedOut) {
    return null;
  }

  const mainText = (
    <>
      You can reapply in {declineLockOut.daysUntilLockOutExpires} day
      {declineLockOut.daysUntilLockOutExpires === 1 ? '' : 's'}
      {compact ? '' : '. '}
    </>
  );
  const helperText = (
    <>
      If you'd like to speak to us about the decision or if you have any
      questions, give us a ring on{' '}
      <span className="text-nowrap">{iwocapayTelDisplay}</span>
    </>
  );

  return (
    <div
      className={clsx('mt-s text-xs font-med text-error', {
        'flex flex-row items-center gap-xs': compact,
      })}
    >
      {mainText}
      {compact ? (
        <Tooltip content={helperText as ReactElement & string}>
          <IconInfoCircleOutline className="inline" />
        </Tooltip>
      ) : (
        helperText
      )}
    </div>
  );
}
